import { SoundResourceType } from '@pp/core';

export const soundResources: SoundResourceType[] = [
  {
    name: 'betSpotNumber',
    url: './assets/sounds/BetSpotNumber.mp3',
  },
  {
    name: 'win',
    url: './assets/sounds/Win.mp3',
  },
  {
    name: 'megaMultiplierReveal',
    url: './assets/sounds/MegaMultiplierReveal.mp3',
  },
  {
    name: 'megaWin',
    url: './assets/sounds/MegaWin.mp3',
  },
];

export enum GameVolumeChannels {
  Studio = 'studio',
  Game = 'game',
}
